import { stores } from '../../../translations';

export const timeZones = {
  [stores.ru]: '00+03:00',
  [stores.kz]: '00+06:00',
  [stores.ae]: '00+04:00',
};
